import { render, staticRenderFns } from "./FormContactsListActions.vue?vue&type=template&id=377d8bd8&"
import script from "./FormContactsListActions.vue?vue&type=script&lang=js&"
export * from "./FormContactsListActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports